import { z } from 'zod'

import type { SearchTermDataRead } from '@/client'

const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined)

/** The history's URL state: the two days and the quick search. */
export const searchTermEntriesSearchSchema = z.object({
  from: day.describe('First day of the history, YYYY-MM-DD; default 30 days before today.'),
  to: day.describe('Last day of the history, YYYY-MM-DD; default tomorrow.'),
  q: z
    .string()
    .max(200)
    .optional()
    .catch(undefined)
    .describe('Quick search: keeps entries with any field containing the text.'),
})
export type SearchTermEntriesSearch = z.infer<typeof searchTermEntriesSearchSchema>

/** `YYYY-MM-DD` of a local day, `offset` days from today. */
function dayFrom(offset: number, today: Date = new Date()): string {
  const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + offset)
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

/** VentaHub's default window: the last 30 days, through tomorrow. */
export function defaultWindow(today: Date = new Date()): { from: string; to: string } {
  return { from: dayFrom(-30, today), to: dayFrom(1, today) }
}

/** The entries the quick search keeps: any column containing the text. */
export function matchesEntry(entry: SearchTermDataRead, query: string | undefined): boolean {
  if (!query) return true
  const needle = query.trim().toLowerCase()
  return Object.values(entry).some((value) =>
    value === null || value === undefined ? false : String(value).toLowerCase().includes(needle),
  )
}
